export default {
    paymentType: {
        cash: 'Cash',
        card: 'Card'
    },
    paymentType2: {
        cash: 'Cash',
        card: 'Card'
    },
    deliveryType: {
        delivery: 'Delivery',
        pickup: 'Pickup'
    },
    deliveryCities: {
        baku: 'Bakı',
        sumgayit: "Sumqayıt",
        khirdalan: "Xırdalan",
        ganja: "Gəncə",
        barda: "Bərdə",
        mingachevir: "Mingəçevir",
        shamkir: "Şəmkir",
        //other: 'Digər'
    },
    feedbackType: {
        info: 'Information',
        comment: 'Suggestion or comment'
    },
    cities: {
        1: "Baku",
        2: "Sumqayit",
        3: "Bərdə",
        4: "Mingəçevir",
        5: "Gəncə",
        6: "Şəmkir",
    },
}
